import { render, staticRenderFns } from "./AdvertisingIntegrations.vue?vue&type=template&id=22703b08&"
import script from "./AdvertisingIntegrations.vue?vue&type=script&lang=js&"
export * from "./AdvertisingIntegrations.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisingIntegrations.vue?vue&type=style&index=0&id=22703b08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports